// extracted by mini-css-extract-plugin
export default {"disabledLabel":"InPageNotificationsConfig-disabledLabel-0307c08da4725814bec0587f3020e48c"};